<template>
  <div>
    <button
      v-show="!visible"
      id="btnPopupShow"
      :class="btnClasses"
      @click="show"
    >
      <slot />
    </button>
    <transition name="modal">
      <div v-show="visible" class="add-remove-list-modal-mask" tabindex="-1">
        <div class="add-revemo-list-modal-wrapper" tabindex="-1">
          <div
            id="addToRemoveList-modal"
            class="addToRemoveList-modal"
            tabindex="-1"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header shadow">
                  <Title :page="page" :is-modal="true" class="custom-title" />
                </div>
                <div
                  id="AddToRemoveList-form form-inline"
                  class="addToRemoveList-form"
                >
                  <div class="row modal-body">
                    <!-- Left Column -->
                    <div
                      class="col-5 col-sm col-12 modal-colum modal-colum-fixed-size"
                    >
                      <div class="tag-badge-info text-left">
                        <span class="tag-badge-title-info">
                          {{ removedColumnDescription }}
                        </span>
                      </div>
                      <div class="modal-left-col vertical-scroll">
                        <ul class="fixed-height">
                          <li
                            v-for="option in removedColumnList"
                            :key="option[objectKey]"
                            :value="option[objectKey]"
                            :class="{
                              addList: isAdded(
                                option[objectKey],
                                removedSelected
                              ),
                              elementDisabled: disabledPredicate(option),
                            }"
                            @click="handleItemClick($event, removedSelected)"
                          >
                            {{ option[objectDescription] }}
                          </li>
                        </ul>
                      </div>
                      <button
                        id="btnPopupAddAll"
                        type="button"
                        class="btn btn-link no-border"
                        @click="addAll"
                      >
                        {{ addAllDescription }}
                      </button>
                    </div>

                    <!-- Center Column -->
                    <div class="col-2 col-sm col-12 modal-colum center-column">
                      <div class="modal-center-col">
                        <button
                          id="btnPopupAdd"
                          type="button"
                          class="btn"
                          @click="handleAdd"
                        >
                          Añadir
                          <i class="fas fa-chevron-right" />
                        </button>
                        <button
                          v-if="removeOption"
                          id="btnPopupRemove"
                          type="button"
                          class="btn"
                          @click="handleRemove"
                        >
                          <i class="fas fa-chevron-left" />
                          Remover
                        </button>
                      </div>
                    </div>

                    <!-- Right Column -->
                    <div
                      class="col-5 col-sm col-12 modal-colum modal-colum-fixed-size"
                    >
                      <div class="tag-badge-info text-left">
                        <span class="tag-badge-title-info">
                          {{ addedColumnDescription }}
                        </span>
                      </div>
                      <div class="modal-right-col vertical-scroll">
                        <ul class="fixed-height">
                          <li
                            v-for="option in addedColumnList"
                            :key="option[objectKey]"
                            :value="option[objectKey]"
                            :class="{
                              addList: isAdded(
                                option[objectKey],
                                addedSelected
                              ),
                              elementDisabled: disabledPredicate(option),
                            }"
                            @click="handleItemClick($event, addedSelected)"
                          >
                            {{ option[objectDescription] }}
                          </li>
                        </ul>
                      </div>
                      <button
                        v-if="removeOption"
                        id="btnPopupRemoveAll"
                        type="button"
                        class="btn btn-link no-border"
                        @click="removeAll"
                      >
                        {{ removeAllDescription }}
                      </button>
                    </div>
                  </div>
                </div>
                <div v-if="true" class="modal-footer">
                  <ActionButton
                    id="modal-btn-cancelar"
                    variant="btn btn-outline-danger btn-cancel danger"
                    type="button"
                    i="fas fa-times-circle"
                    @click="handleCancel"
                  >
                    Cancelar
                  </ActionButton>
                  <ActionButton
                    id="modal-btn-anadir"
                    variant="success"
                    type="button"
                    i="fas fa-file-plus"
                    data-target="#modal-cambiar"
                    @click="handleSave"
                  >
                    Aplicar
                  </ActionButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Title from './page/Title';
import ActionButton from './ActionButton';

export default {
  name: 'CustomAddRemoveListPopup',
  meta: {
    description:
      'Componente personalizado para botones  de agregar o quitar lista',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    btnClasses: {
      type: String,
      default: '',
      meta: {
        description: 'Estilos para el botón',
        example: 'Texto requerido',
      },
    },
    addedList: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: 'Propiedad para agregar listas ',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    removedList: {
      type: Array,
      default: () => new Array(),
      meta: {
        description: 'Propiedad para eliminar listas ',
        example: '[4, 8, 15, 16, 23, 42]',
      },
    },
    objectKey: {
      type: String,
      required: true,
      meta: {
        description: 'Estable el id del objeto',
        example: 'Texto requerido',
      },
    },
    objectDescription: {
      type: String,
      required: true,
      meta: {
        description: 'Estable la descripción del objeto',
        example: 'Texto requerido',
      },
    },
    disabledPredicate: {
      type: Function,
      default: () => false,
      meta: {
        description: 'Propiedad para deshabilitar',
        example: '(value) => { return value.toUpperCase() }',
      },
    },
    initialShowState: {
      type: Boolean,
      default: false,
      meta: {
        description: 'Establece el estado inicial',
        example: 'true',
      },
    },
    title: {
      type: String,
      default: 'Selección de Evaluaciones',
      meta: {
        description: 'Estable el encabezado',
        example: 'Texto requerido',
      },
    },
    removedColumnDescription: {
      type: String,
      default: 'removedColumnDescription',
      meta: {
        description: 'Propiedad para eliminar descripción en columnas ',
        example: 'Texto requerido',
      },
    },
    addedColumnDescription: {
      type: String,
      default: 'addedColumnDescription',
      meta: {
        description: 'Propiedad para agregar descripción en columnas ',
        example: 'Texto requerido',
      },
    },
    addAllDescription: {
      type: String,
      default: 'Agregar Todas',
      meta: {
        description: 'Propiedad para agregar todas las descripciones',
        example: 'Texto requerido',
      },
    },
    removeAllDescription: {
      type: String,
      default: 'Remover Todas',
      meta: {
        description: 'Propiedad para remover todas las descripciones',
        example: 'Texto requerido',
      },
    },
    removeOption: {
      type: Boolean,
      default: true,
      meta: {
        description: 'Permite remover opciones',
        example: 'true',
      },
    },
  },
  components: {
    Title,
    ActionButton,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-file-export',
        iconFontSize: 14,
        title: this.title,
      },
      addedSelected: [],
      removedSelected: [],
      addedColumnList: [],
      removedColumnList: [],
      visible: false,
    };
  },
  methods: {
    isAdded(id, collection) {
      return collection.toString().indexOf(id) > -1;
    },
    addAll() {
      this.handleItemTransfer(
        this.removedColumnList,
        this.addedColumnList,
        this.removedColumnList.map((x) => {
          if (!this.disabledPredicate(x)) {
            return x[this.objectKey];
          }
        })
      );
    },
    removeAll() {
      this.handleItemTransfer(
        this.addedColumnList,
        this.removedColumnList,
        this.addedColumnList.map((x) => {
          if (!this.disabledPredicate(x)) {
            return x[this.objectKey];
          }
        })
      );
    },
    handleCancel() {
      this.refreshFromSource();
      this.hide();
    },
    handleSave() {
      this.$emit('updated', this.addedColumnList, this.removedColumnList);
      this.refreshFromSource();
      this.handleCancel();
    },
    handleOnCreate() {
      this.$emit('created');
    },
    handleItemClick(event, collection) {
      if (event.target.classList.contains('elementDisabled')) {
        event.preventDefault();
        return false;
      } else {
        const index = collection.indexOf(event.target.value);
        if (index > -1) {
          collection.splice(index, 1);
        } else {
          collection.push(event.target.value);
        }
      }
    },
    handleItemTransfer: function(source, to, itemsToMove) {
      for (let i = 0; i < source.length; i++) {
        const element = source[i];

        if (itemsToMove.some((x) => x == element[this.objectKey])) {
          source.splice(i, 1);
          to.push(element);
          i--;
        }
      }

      this.addedSelected = [];
      this.removedSelected = [];
    },
    handleAdd: function() {
      return this.handleItemTransfer(
        this.removedColumnList,
        this.addedColumnList,
        this.removedSelected
      );
    },
    handleRemove: function() {
      return this.handleItemTransfer(
        this.addedColumnList,
        this.removedColumnList,
        this.addedSelected
      );
    },
    hide() {
      this.visible = false;
      this.addedSelected = [];
      this.removedSelected = [];
      document.body.style.overflowY = '';
      this.$emit('hide');
    },
    show() {
      this.visible = true;
      this.refreshFromSource();
      document.body.style.overflowY = 'hidden';
    },
    refreshFromSource() {
      this.removedColumnList = Array.from(this.removedList);
      this.addedColumnList = Array.from(this.addedList);
    },
  },
  mounted() {
    this.visible = this.initialShowState;
    this.handleOnCreate();
    this.refreshFromSource();
  },
};
</script>

<style scoped>
.addToRemoveList-modal .modal-dialog {
  max-width: 884px;
  width: 100%;
}
.addToRemoveList-modal .modal-dialog .modal-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 10px;
  height: 29px;
  padding-bottom: 0;
}
.addToRemoveList-modal .modal-dialog .modal-title span {
  font-size: 18px;
}
.addToRemoveList-modal .modal-dialog .modal-title-icon-container {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.addToRemoveList-modal .modal-dialog .modal-title-icon-container i {
  font-size: 0.9rem;
}

.addToRemoveList-modal .modal-dialog .row {
  margin: 0px;
}
.addToRemoveList-form .modal-body,
.addToRemoveList-form .modal-colum {
  display: flex;
}
.addToRemoveList-form .modal-body {
  flex-direction: row;
  display: flex;
  justify-content: center;
  align-items: center;
}
.addToRemoveList-form .modal-colum {
  width: 100%;
  max-width: 314px;
  flex-direction: column;
}
.addToRemoveList-form .modal-colum ul {
  list-style: none;
  padding: 5px 0 5px 0;
}
.addToRemoveList-form .modal-colum ul li {
  font-size: 14px;
  margin: 5px 0px;
  padding: 2px 15px;
  cursor: pointer;
}
.addToRemoveList-form .modal-colum ul li:hover {
  background-color: #d9e5df;
}
.addToRemoveList-form .modal-colum ul li.addList {
  background-color: #2db782;
  color: #ffffff;
}
.addToRemoveList-form .modal-colum button {
  text-align: left;
  padding-left: 0px;
  color: #2db782;
  text-decoration: underline;
}
.addToRemoveList-form .modal-colum .tag-badge-title-info {
  padding-left: 15px;
  font-weight: 800;
  color: black;
}

.addToRemoveList-form .modal-left-col,
.addToRemoveList-form .modal-right-col {
  min-height: 217px;
  height: 100%;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  margin: 15px 0;
}
.addToRemoveList-form .center-column {
  justify-content: center;
  align-items: center;
}
.addToRemoveList-form .modal-center-col {
  max-width: 105px;
  width: 100%;
}
.addToRemoveList-form .modal-center-col button {
  width: 100%;
  height: 29px;
  margin: 25px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  color: #fff;
  font-weight: 800;
  text-decoration: none;
  background-color: #c9545e;

  border: 0px;
}
.addToRemoveList-form .modal-center-col button:first-child {
  background-color: #2db782;
}
.addToRemoveList-form .modal-center-col button i.fa-chevron-right {
  padding-left: 12px;
}
.addToRemoveList-form .modal-center-col button i.fa-chevron-left {
  padding-right: 6px;
}
.addToRemoveList-modal .modal-content {
  border-radius: 0px;
}
.addToRemoveList-form .modal-footer {
  border-top: 0px;
  padding-bottom: 30px;
  padding-right: 65px;
}
.addToRemoveList-form .modal-footer .footer-col {
  display: flex;
  justify-content: flex-end;
}
.addToRemoveList-form .modal-footer .footer-col button {
  font-size: 1rem;
  font-weight: 600;
  height: 43px;
}
.addToRemoveList-form .modal-footer .footer-col button.btn-cancel {
  margin-right: 15px;
  color: #c9545e;
  border-color: #c9545e;
  max-width: 124px;
  width: 100%;
}
.addToRemoveList-form .modal-footer .footer-col button.btn-cancel:hover {
  background-color: #c9545e;
  color: #ffffff;
}
.addToRemoveList-form .modal-footer .footer-col button.btn-cancel i {
  font-size: 17px;
}
.add-remove-list-modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.add-revemo-list-modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.elementDisabled {
  color: grey;
  cursor: not-allowed !important;
}

.addToRemoveList-form .modal-colum ul li.elementDisabled:hover {
  background-color: white;
  color: grey;
}

.fixed-height {
  height: 217px;
}

.vertical-scroll {
  overflow-y: auto;
}

.addToRemoveList-modal {
  outline: none;
}

.btn.btn-link.no-border {
  border: none;
}

.modal-colum-fixed-size {
  min-height: 21em;
}

@media only screen and (max-width: 768px) {
  .custom-title >>> .tag-badge-title {
    font: Bold 18px/30px Lato !important;
  }
  .modal-content {
    width: 96%;
  }
  .modal-right-col.vertical-scroll {
    min-height: auto;
    height: auto;
    margin: unset;
  }
  .modal-colum.modal-colum-fixed-size {
    min-height: auto;
  }
  .modal-left-col.vertical-scroll {
    min-height: auto;
  }
  .fixed-height {
    height: 100px;
  }
  .addToRemoveList-form {
    height: 460px;
    overflow-y: auto;
    background: #fff;
  }
}
</style>
